import { SERVICE_CONFIG } from "./service";

// Centralized FAQ configuration
export interface FAQ {
  question: string;
  answer: string;
}

export const FAQS: FAQ[] = [
  {
    question: 'Unde poate fi ascultat cântecelul?',
    answer: `Cântecelul tău poate fi redat ușor pe orice dispozitiv:\n\n📱 Telefon (iPhone / Android)\n💻 Tabletă sau laptop\n🔊 Boxe sau sistem audio\n📺 Google Cast (Chromecast, Android TV, boxe compatibile)\n🎧 Yoto Player – cu card personalizat`,
  },
  {
    question: 'Cum funcționează procesul de creare a unei melodii?',
    answer: `După ce completezi formularul de comandă cu detaliile despre copilul tău, echipa noastră de compozitori va crea o melodie personalizată în ${SERVICE_CONFIG.deliveryDaysText}.`,
  },
  {
    question: 'Cât timp durează livrarea melodiei?',
    answer: `Timpul standard de livrare este de ${SERVICE_CONFIG.deliveryDaysText} de la confirmarea comenzii și plata acesteia. Pentru proiecte urgente sau complexe, termenul poate fi mai lung - te vom informa în prealabil.`,
  },
  {
    question: 'Pot solicita modificări după ce primesc melodia?',
    answer: 'Da, oferim până la 2 runde de modificări gratuite. Dacă ai nevoie de mai multe modificări, acestea vor fi taxate suplimentar. Te rugăm să specifici cât mai clar posibil cerințele în formularul inițial.',
  },
  {
    question: 'Ce formate primesc fișierul audio?',
    answer: 'Primești melodia în format MP3 de înaltă calitate (320kbps), potrivit pentru redare pe orice dispozitiv. Fișierul este optimizat pentru streaming și descărcare.',
  },
  {
    question: 'Melodia va fi originală sau va folosi muzică existentă?',
    answer: 'Fiecare melodie este compusă special pentru copilul tău, de la zero. Nu folosim șabloane sau muzică existentă - totul este creat original, inspirat din povestea și personalitatea copilului.',
  },
  {
    question: 'Pot folosi melodia comercial?',
    answer: 'Da, drepturile de autor asupra melodiei create îți aparțin integral. Poți folosi melodia pentru uz personal, comercial sau o poți distribui cum dorești.',
  },
  {
    question: 'Ce se întâmplă dacă nu sunt mulțumit de rezultat?',
    answer: 'Satisfacția clienților noștri este prioritatea noastră. Dacă nu ești complet mulțumit, vom lucra cu tine până când rezultatul îți va plăcea. În cazuri rare când nu putem ajunge la un acord, oferim rambursarea integrală.',
  },
  {
    question: 'Pot comanda o melodie pentru mai mulți copii?',
    answer: 'Da, poți comanda melodii separate pentru fiecare copil. Pentru familii cu mai mulți copii, oferim discounturi speciale - contactează-ne pentru detalii.',
  },
  {
    question: 'Cum primesc melodia finală?',
    answer: 'După finalizarea creației, vei primi un email cu link-ul de descărcare securizat. Melodia va fi disponibilă și în contul tău de pe site pentru descărcări viitoare.',
  },
  {
    question: 'Acceptați plăți în rate?',
    answer: 'Pentru pachetul Premium cu preț personalizat, putem discuta opțiuni de plată în rate. Pentru pachetul "Primul Refren", plata se face integral la comandă.',
  },
  {
    question: 'Pot anula comanda după ce am plătit?',
    answer: 'Da, poți anula comanda în termen de 24 de ore de la plată pentru rambursarea integrală. După primirea melodiei, nu mai poți solicita anularea.',
  },
] as const;
